<template>
  <div>
    <p class="title-tip">只有N+UV考核的单才可配置此内容</p>
    <ContentBox title="曝光频次占比" class="content-box">
      <el-form ref="form" :model="model" :rules="rules" label-width="60px" label-position="left" hide-required-asterisk>
        <el-row  v-if="ruleList.length">
          <el-col :span="11">
            <div class="top-tit">计划单</div>
          </el-col>
          <el-col :span="12">
            <div class="top-tit">曝光频次占比</div>
          </el-col>
          <el-col :span="1">
            <div class="top-tit">操作</div>
          </el-col>
        </el-row>
        <el-row class="eborder"  v-for="(item, index) in ruleList" :key="index">
          <el-col :span="11" class="left-wrap box">
            <div style="margin-bottom: 20px">
              <ScheduleList
                v-model="item.data"
                :index="index"
                :ruleList="ruleList"
                :scheduleInfo="scheduleForm"
                @confirm="scheduleListHandle"
                @remove="removeSchedule"
              ></ScheduleList>
            </div>
            <Table
              :props="table.props"
              :ref="'table'+index"
              :header="table.header"
              :data="item.data"
              :selected="item.selected"
              :selection-type="table.selectionType"
              @row-selection-add="handleRowSelectionAdd($event, index)"
              @row-selection-remove="handleRowSelectionRemove($event, index)"
              @all-row-selection-change="handleAllRowSelectionChange($event, index)"
            />
          </el-col>
          <el-col :span="12" class="rwrap">
            <div class="right-wrap box">
              <div><el-form-item label="规则" prop="pvRatioType">
                <el-radio-group v-model="item.pvRatioType" @change="handleChangePvRatioType">
                  <el-radio-button :label="0">默认<el-tooltip effect="light" placement="top-start">
                    <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                    <div slot="content">
                      <div>例：计划单整单控5次，考核4+大于60%</div>
                      <div>默认：曝光4、5的所需设备均分后分别占比30%；3、2、1用剩下的40%均分后，所需设备分别为13.33%、13.33%、13.34% </div>
                    </div>
                  </el-tooltip></el-radio-button>
                  <el-radio-button :label="1">自定义<el-tooltip effect="light" placement="top-start">
                    <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                    <div slot="content">自定义配置各频次占比，未配置的频次，占比按百分比-配置的执行</div>
                  </el-tooltip></el-radio-button>
                </el-radio-group>
              </el-form-item>
                <div class="ratiolist-wrapper" v-if="item.pvRatioType !== 0">
                  <PvFrequency
                    ref="PvFrequency"
                    :item="item"
                    v-model="item.uvRateList"
                    @change="pvFrequencyChange"
                  ></PvFrequency>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="1" class="action-bar">
            <el-button class="remove-btn" type="text" @click="removeRow(index)">移除</el-button>
          </el-col>
        </el-row>
        <div style="margin-top: 20px">
          <el-button @click="addRule">添加规则</el-button>
        </div>
      </el-form>
    </ContentBox>
    <ContentBox class="content-box">
      <el-button type="primary" @click="save()">保存</el-button>
    </ContentBox>
  </div>
</template>
<script>
import CheckBoxGroup from '@/components/CheckBoxGroup'
import PvFrequency from '@/components/schedule/PvFrequency.vue'
import ScheduleList from '@/components/schedule/ScheduleList.vue'
export default {
  components: {
    CheckBoxGroup,
    PvFrequency,
    ScheduleList
  },
  props: {
    orderNo: {
      type: String
    },
    uploadInfo: Object,
    baseInfo: Object
  },
  data() {
    let validateReceivePct = (rule, value, callback) => {
      if ((rule.field === 'receivePct' && this.receivePctType === 0) || (rule.field === 'exposurePct' && this.exposurePctType === 0)) {
        return callback()
      }
      if (value === '') {
        return callback(new Error('请输入溢出比'))
      }
      if (!Number.isInteger(value * 1) || value * 1 < 0 || (rule.field === 'exposurePct' && value * 1 === 0)) {
        return callback(new Error('请输入正整数'))
      }
      if (rule.field === 'receivePct' && value > 100000) {
        return callback(new Error('溢出比不能超过100000,请重新输入'))
      }
      if (rule.field === 'exposurePct' && value > 100) {
        return callback(new Error('溢出比不能超过100,请重新输入'))
      }
      callback()
    }
    return {
      initScheduleList: [],
      currentIndex: 0,
      scheduleForm: this.genScheduleForm(),
      cleanBtnDisabled: false,
      otherConfigId: undefined,
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '计划单号',
            align: 'center',
            prop: 'scheduleNo',
            'min-width': 155,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '计划名称',
            align: 'left',
            prop: 'scheduleName',
            'min-width': 200,
            isShow: true,
            'show-overflow-tooltip': true
          }
        ],
        data: [],
        selected: [],
        selectionType: 'multiple'
      },
      selected: [],
      selectedRow: [],
      ruleList: [],
      rules: {
        orderId: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        spaceId: [{ required: true, message: '请选择广告位', trigger: 'blur' }],
        planType: [{ required: true, message: '请选择计划类型', trigger: 'blur' }],
        scheduleSource: [{ required: true, message: '请选择程序化来源', trigger: 'blur' }],
        payment: [{ required: true, message: '请选择结算方式', trigger: 'blur' }],
        trafficSpeed: [{ required: true, message: '请选择投放速度', trigger: 'blur' }],
        receivePct: [{ validator: validateReceivePct, trigger: 'blur' }],
        exposurePct: [{ validator: validateReceivePct, trigger: 'change' }],
        cableChannelList: [{ required: true, message: '请至少选择一个媒体方', trigger: 'change' }]
      },
      model: {
      }
    }
  },
  watch: {},
  computed: {},
  methods: {
    initData() {
      const filter = {
        orderNoOrName: this.orderNo,
        pageSize: this.$parent.$parent.$refs.BatchBusiness.scheduleIds.length + 1,
        pageNo: 1,
        scheduleIds: this.$parent.$parent.$refs.BatchBusiness.scheduleIds,
      }
      this.$service.getScheduleList(filter).then(data => {
        this.initScheduleList = data.rows || []
      })
        .catch(() => {
          this.loading = false
        })
    },
    initRule() {
      return {
        data: [],
        uvRateList: [
          {
            uvMatch: 0,
            frequency: '',
            uvPercentage: '',
            minFrequency: '',
            maxFrequency: ''
          }
        ],
        pvRatioType: 0,
        selected: [],
        selectedRow: [],
        ids: []
      }
    },
    genScheduleForm() {
      return {
        scheduleTaUvId: '',
        pvRatioType: 0, // 曝光频次占比类型
        pvRatioList: [
          {
            uvMatch: 0,
            frequency: '',
            uvPercentage: '',
            minFrequency: '',
            maxFrequency: ''
          }
        ]
      }
    },
    handleCleanAllSelectTable(val) {
      this.selectTable.data = []
      if (this.scheduleForm.unionSequence === 1) {
        this.scheduleForm.unionFreq = this.scheduleForm.trafficDaily
        this.scheduleForm.subUnionFreq = this.scheduleForm.subTrafficDaily
      }
    },
    scheduleListHandle(data, index) {
      let ind = index || 0
      // this.ruleList[ind].data = data
      let ruleThis = (this.ruleList[ind].data || [])
      let ids = ruleThis.map(item => item.scheduleId)
      let filData = (data || []).filter(item => !ids.includes(item))
      this.ruleList[ind].data = ruleThis.concat(filData)
    },
    handleChangePvRatioType(e) {},
    pvFrequencyChange(e) {},
    save(type) {
      let scheduleIds = this.$parent.$parent.$refs.BatchBusiness.scheduleIds
      if (this.ruleList.length === 0) {
        this.$message.error('请添加规则')
        return
      }
      let ids = []
      this.ruleList.forEach(item => {
        (item.data || []).forEach(it => {
          ids.push(it.scheduleId)
        })
      })
      if (ids.length < scheduleIds.length) {
        let tip = []
        this.initScheduleList.forEach(item => {
          if (!ids.includes(item.scheduleId)) {
            tip.push(`【${item.scheduleNo}】${item.scheduleName}`)
          }
        })
        this.$message.error(tip.join('、') + '未配置曝光占比')
        return
      }
      const validateArr = []
      validateArr.push(
        new Promise((resolve, reject) => {
          this.$refs.form.validate(valid => {
            if (valid) resolve()
          })
        })
      )
      if (this.$refs.PvFrequency && this.$refs.PvFrequency.length) {
        this.$refs.PvFrequency.forEach(item => {
          validateArr.push(
            new Promise((resolve, reject) => {
              item.$refs.form.validate(valid => {
                if (valid) resolve()
              })
            })
          )
        })
      }
      Promise.all(validateArr).then(res => {
        this.saveForm(type)
      })
    },
    saveForm(type) {
      let uvRateList = []
      this.ruleList.forEach(item => {
        if (item.pvRatioType === 1) {
          (item.uvRateList || []).forEach(it => {
            if (it.uvMatch === 0) { // 等于
              item.data.forEach(ite => {
                uvRateList.push({
                  orderId: ite.orderId,
                  scheduleId: ite.scheduleId,
                  minFrequency: it.frequency,
                  maxFrequency: it.frequency,
                  uvPercentage: it.uvPercentage,
                  uvMatch: it.uvMatch,
                })
              })
            } else if (it.uvMatch === 1) { // 区间
              item.data.forEach(ite => {
                uvRateList.push({
                  orderId: ite.orderId,
                  scheduleId: ite.scheduleId,
                  minFrequency: it.minFrequency,
                  maxFrequency: it.maxFrequency,
                  uvPercentage: it.uvPercentage,
                  uvMatch: it.uvMatch,
                })
              })
            }
          })
        } else if (item.pvRatioType === 0) {
        }
      })
      let params = {
        uvRateList: uvRateList,
        orderId: this.baseInfo.orderId,
        scheduleIds: this.$parent.$parent.$refs.BatchBusiness.scheduleIds
      }
      // 判断是否有N+UV
      this.$service
        .addScheduleUvRate(params)
        .then(data => {
          this.buttonSaveLoading = false
          this.buttonSubmitLoading = false
          this.$notify({ title: '操作成功', message: '保存成功', type: 'success' })
          this.$emit('refresh', true)
        })
        .catch(() => {
          this.buttonSaveLoading = false
          this.buttonSubmitLoading = false
        })
    },
    handleRowSelectionAdd(targetItem, index) {
      this.ruleList[index].ids.push(targetItem.scheduleId)
      this.ruleList[index].selectedRow.push(targetItem)
      this.updateTableSelected(index)
    },
    updateTableSelected(index) {
      const newSelectedIndex = this.ruleList[index].ids
      this.ruleList[index].selected = this.ruleList[index].data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.scheduleId) > -1) {
          result.push(index)
        }
        return result
      }, [])
    },
    handleRowSelectionRemove(targetItem, index) {
      this.ruleList[index].ids = this.ruleList[index].ids.filter((item) => {
        return item !== targetItem.scheduleId
      })
      this.ruleList[index].selectedRow = this.ruleList[index].selectedRow.filter((item) => {
        return item.scheduleId !== targetItem.scheduleId
      })
      this.updateTableSelected(index)
    },
    handleAllRowSelectionChange(value, index) {
      if (value) {
        this.ruleList[index].data.forEach(item => {
          this.handleRowSelectionAdd(item, index)
        })
      } else {
        this.ruleList[index].selectedRow = []
        this.ruleList[index].selected = []
        this.ruleList[index].ids = []
      }
    },
    addRule() {
      this.ruleList.push(this.initRule())
    },
    removeRow(index) {
      this.ruleList.splice(index, 1)
    },
    removeSchedule(index) {
      this.ruleList[index].data = this.ruleList[index].data.filter(item => !this.ruleList[index].ids.includes(item.scheduleId))
      this.ruleList[index].selected = []
      this.ruleList[index].ids = []
      this.ruleList[index].selectedRow = []
    },
  },
  created() {
  },
  mounted() {
    this.initData()
  }
}
</script>
<style lang="stylus" scoped>
  >>> .el-table__empty-block {
    margin-left -1px
    border-right 1px solid #EBEEF5
  }
  >>> .rangeItem {
    margin-top 8px
  }
  .ratiolist-wrapper {
    >>> .nuv-wrap {
        margin-bottom 0!important
      .col5 {
        margin-top: 8px;
      }
    }
  }
  .eborder {
    display flex
    margin-top: -1px;
    border 1px solid #EBEEF5
  }
  .title-tip {
    position absolute
    top 25px
    left 150px
    font-size 12px
    color rgba(0,0,0,0.45)
  }
  .top-tit {
    color rgba(0,0,0,0.85)
    font-size 12px
    padding 10px 0
    text-align center
    background #F2F2F2
  }
  .box {
    padding: 20px;
    .total {
      margin-left 10px
      font-size 12px;
      color rgba(0,0,0,0.85)

    }
  }
  .left-wrap {
    border-right 1px solid #EBEEF5
  }
  .rwrap {
    display flex
    align-items center
  }
  .action-bar {
    display flex
    align-items center
    justify-content center
    border-left 1px solid #EBEEF5
  }
</style>
